import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";

import { fetchCheckStatus } from "@/lib/api";

export default function BetalingSucces() {
  const [params] = useSearchParams();
  const checkId = params.get("check");
  const [status, setStatus] = useState(null);
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    if (!checkId) return;
    let cancelled = false;
    let interval;
    async function tick() {
      try {
        const s = await fetchCheckStatus(checkId);
        if (cancelled) return;
        setStatus(s);
        if (s.payment_status === "paid" && !redirected) {
          setRedirected(true);
          setTimeout(() => {
            window.location.href = `/result/${checkId}?fresh=1`;
          }, 1200);
        }
      } catch (e) { /* ignore */ }
    }
    tick();
    interval = setInterval(tick, 2000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [checkId, redirected]);

  const paid = status?.payment_status === "paid";

  return (
    <div className="py-24" data-testid="payment-success-page">
      <div className="max-w-xl mx-auto px-6 text-center">
        <div className="h-20 w-20 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto">
          {paid ? <CheckCircle2 className="h-10 w-10 text-[#10B981]" /> : <Loader2 className="h-10 w-10 text-[#002FA7] animate-spin" />}
        </div>
        <h1 className="font-display text-4xl font-bold text-ink mt-6 tracking-tight">
          {paid ? "Betaling gelukt" : "Betaling wordt bevestigd…"}
        </h1>
        <p className="text-ink-soft mt-3">
          {paid
            ? "We starten je analyse nu. Je wordt binnen enkele seconden doorgestuurd naar je rapport."
            : "Even geduld terwijl we je betaling met MultiSafepay bevestigen."}
        </p>
        {checkId && (
          <Link
            to={`/result/${checkId}`}
            className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#002FA7] hover:bg-[#0033B5] text-white font-semibold"
            data-testid="goto-result"
          >
            Ga naar mijn rapport
          </Link>
        )}
      </div>
    </div>
  );
}
